<template>
    <table>
        <tr
            v-for="(day, index) in days"
            :key="index">
            <td>{{ day.name }}</td>
            <td>
                {{ day.text }}
            </td>
        </tr>
    </table>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        hours: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        days() {
            moment.locale('nl');

            const days = [];

            [
                ['Maandag', 'monday'],
                ['Dinsdag', 'tuesday'],
                ['Woensdag', 'wednesday'],
                ['Donderdag', 'thursday'],
                ['Vrijdag', 'friday'],
                ['Zaterdag', 'saturday'],
                ['Zondag', 'sunday']
            ].forEach((day) => {
                const objectDayName = day[1];
                let text = "";
                const name = day[0];

                if(this.hours[`${objectDayName}_state`] === 'closed') {
                    text = 'Gesloten';
                } else {
                    const fromTime = !this.hours[`${objectDayName}_from`] ? '' : moment(this.hours[`${objectDayName}_from`], 'HH:mm:ss').format('HH:mm');
                    const toTime = !this.hours[`${objectDayName}_to`] ? '' : moment(this.hours[`${objectDayName}_to`], 'HH:mm:ss').format('HH:mm');

                    if(fromTime && toTime) {
                        text = `${fromTime} - ${toTime} uur`;
                    }
                    else {
                        text = 'Geopend';
                    }
                }

                days.push({
                    text,
                    name
                });
            });

            return days;
        }
    }
};
</script>
